import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppTypeDigital = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "appType-Digital",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17532",
		"data-name": "Group 17532",
		transform: "translate(3.333 2)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12958",
				"data-name": "Path 12958",
				d: "M14.333,9V6.219a1.334,1.334,0,0,0-.391-.943L12.057,3.391A1.334,1.334,0,0,0,11.115,3H6.333A1.333,1.333,0,0,0,5,4.333v9.333A1.333,1.333,0,0,0,6.333,15H9",
				transform: "translate(-5 -3)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12959",
				"data-name": "Path 12959",
				d: "M8,9h5.333",
				transform: "translate(-6 -5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12960",
				"data-name": "Path 12960",
				d: "M8,12h5.333",
				transform: "translate(-6 -6)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12961",
				"data-name": "Path 12961",
				d: "M8,15H9.333",
				transform: "translate(-6 -7)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Mobile_Devices_Charging",
				"data-name": "Mobile, Devices, Charging",
				transform: "translate(-4.833 -4.5)",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_12970",
					"data-name": "Path 12970",
					d: "M13.126,17.752A2.626,2.626,0,0,1,10.5,15.126,2.667,2.667,0,0,1,13.128,12.5a2.626,2.626,0,0,1,0,5.252",
					transform: "translate(0 0)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: .9
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_12971",
					"data-name": "Path 12971",
					d: "M14.875,15,14,15.875l1.167.584-.875.875",
					transform: "translate(-1.458 -1.041)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: .9
				})]
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12964",
		"data-name": "Path 12964",
		d: "M0,0H16V16H0Z",
		fill: "none"
	})]
});
export default SvgAppTypeDigital;
